var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0m2.96 14.036H11.34V27.38h3.3v-4.342h6.086l2.887 4.342h3.697l-3.183-4.361c1.173-.177 1.7-.542 2.135-1.142s.653-1.56.653-2.84v-1c0-.761-.08-1.362-.218-1.822a3.1 3.1 0 0 0-.713-1.218 3.2 3.2 0 0 0-1.224-.741c-.474-.14-1.068-.22-1.8-.22m-.533 2.941c.455 0 .771.08.93.221.159.14.256.402.256.78v1.12c0 .402-.097.66-.257.801-.158.141-.474.202-.93.202v-.003H14.64v-3.12zm7.416-8.016a2.539 2.539 0 1 0 0 5.077 2.539 2.539 0 0 0 0-5.077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRutube);
export default __webpack_public_path__ + "static/media/rutube.2da9ee3c.svg";
export { ForwardRef as ReactComponent };